import { render, staticRenderFns } from "./resetPassPage.vue?vue&type=template&id=1ba9af33&scoped=true"
import script from "./resetPassPage.vue?vue&type=script&lang=js"
export * from "./resetPassPage.vue?vue&type=script&lang=js"
import style0 from "./resetPassPage.vue?vue&type=style&index=0&id=1ba9af33&prod&scoped=true&lang=css"
import style1 from "./resetPassPage.vue?vue&type=style&index=1&id=1ba9af33&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9af33",
  null
  
)

export default component.exports